// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "name" , "source", "slide", "output"]

  initialize() {
    this.showCurrentSlide()
  }

  connect() {
    //console.log("In Playground v2")

  }

  get index() {
    return parseInt(this.data.get("index"))
  }

  set index(value) {
    //console.log("Now calling calling set")
    this.data.set("index",value)
    this.showCurrentSlide()
  }

  prev(e) { this.index-- }
  next(e) { this.index++ }

  showCurrentSlide() {
    this.slideTargets.forEach( (el, i) => { el.classList.toggle("slide--current", this.index == i) })
  }

  copy(e) {
    e.preventDefault()
    this.sourceTarget.select()
    document.execCommand("copy")
  }

  greet() {
    this.outputTarget.textContent = `Hello, ${this.name}`
  }

  get name() {
    return this.nameTarget.value
  }


}
